import styled, { css } from 'styled-components';
import {
  SVGIcon,
  Button,
} from '@pearsontechnology/aero-components';

const getBorderColor = (props) => {
  if (props.isDragReject || props.error) {
    return props.theme['color.redLight'];
  }
  if (props.isDragActive) {
    return props.theme['color.blueDark'];
  }
  if (props.acceptedFilesLength > 0) {
    return 'transparent';
  }
  return props.theme['color.input.border'];
};

export const DragHighlightCss = css`
  border-width: 2px;
  border-style: dashed;
  border-color: ${(props) => getBorderColor(props)};
`;

const DisplayProperty = `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`;

const FontProperty = `
  font-size: 14px;
  font-weight: normal;
  font-family: Open Sans;
`;

export const DropzoneContainer = styled.div`
  ${DragHighlightCss};
  ${DisplayProperty};
  margin-top: 6px;
  border-radius: 4px;
  background-color: ${(props) => {
    if (props.isDragReject || props.error) {
      return 'rgba(249, 97, 85, 0.15)';
    } else if (!props.isDragActive) {
      return props.theme.themeId === 'dark'
        ? props.theme['color.input.background']
        : props.theme['color.greyLight'];
    }
    return 'rgba(33, 150, 243, 0.1)';
  }};
  height: 120px;
`;

export const DragAreaText = styled.p`
  margin: 0px;
`;

export const DragAreaInput = styled.input`
  background: ${(props) => props.theme['color.text.light']};
`;

export const DragAreaLink = styled.button`
  text-decoration-line: underline;
  color: ${(props) => props.theme['color.blueLight']};
  cursor: pointer;
  span {
    border-bottom: none;
    box-shadow: none;
  }
`;

export const DragAreaDiv = styled.div`
  ${DisplayProperty};
  ${FontProperty};
`;

export const ErrorInfo = styled.p`
  display: flex;
  flex-direction: row;
  transition: all 0.3s ease;
  font-size: 14px;
  color: ${(props) =>
    props.theme.themeId === 'dark'
      ? props.theme['color.redLight']
      : props.theme['color.redDark']};
  margin: 0;
  overflow: hidden;
  padding-top: 6px;

  & > svg {
    margin-right: 6px;
    width: 22px;
    height: 22px;
  }
`;
export const DroppedFileName = styled.div`
  ${DisplayProperty};
  justify-content: space-between;
  flex-direction: row;
  padding: 20px;
  width: 100%;
`;

export const FileIcon = styled(SVGIcon)`
  opacity: 0.6;
  margin-right: 5px;
`;

export const CancelButton = styled(Button)`
  opacity: 0.8;
`;

export const FileNameWrapper = styled.p`
  width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
